var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArchiveBox = function SvgIconArchiveBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.64 13.515a1 1 0 0 1 1.414 0l.946.946V10.5a1 1 0 1 1 2 0v3.96l.946-.945a1 1 0 0 1 1.414 1.414l-2.643 2.643a1 1 0 0 1-.954.275 1 1 0 0 1-.47-.265L8.64 14.93a1 1 0 0 1 0-1.414"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2.75a1 1 0 0 0-.914.594L2.845 6.699a1 1 0 0 0-.095.426V19.5a1.75 1.75 0 0 0 1.75 1.75h15a1.75 1.75 0 0 0 1.75-1.75V7.125a1 1 0 0 0-.095-.426l-1.491-3.355a1 1 0 0 0-.914-.594zm13.461 3.375-.61-1.375H5.9l-.611 1.375zm-13.961 2V19.25h14.5V8.125z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArchiveBox;